<template>
  <div class="tickets-ativos" :class="{'nodata': !remocoes || remocoes.length === 0}">
    <h3>Tickets Ativos</h3>

    <div v-for="remocao in remocoes" :key="remocao.id" class="item">
      <h4>{{ remocao.categoria ? remocao.categoria.traducao.es : 'Em preenchimento'}}</h4>
      <h5>{{ remocao.nomeVeiculo ? remocao.nomeVeiculo : 'Em preenchimento'}}</h5>
      <small><b>De: </b>{{ remocao.enderecoRecolhimento ? remocao.enderecoRecolhimento : 'Aguardando definição no atendimento'}}</small>
      <small><b>Para: </b>{{ remocao.patioDestino ? remocao.patioDestino.nome : 'Aguardando definição no atendimento'}}</small>
      <small v-if="remocao.reboquista">R: {{ remocao.reboquista.nome }}</small>
      <small v-if="remocao.dataInicio">Solicitado em {{ remocao.dataInicio.date|formatDate('DD/MM HH:mm') }}</small>
      <ul>
        <li v-for="etapa in remocao.etapas" :class="{'ativo': etapa.active, 'completed': etapa.completed}">{{
          etapa.descricao }}
        </li>
      </ul>
      <context-menu-remocao-ticket v-show="remocao.etapa < 4" :remocao="remocao" />
    </div>

    <div class="wrapper" v-if="!remocoes || remocoes.length === 0">
      Nenhum ticket ativo. Inicie um atendimento.
    </div>
  </div>
</template>

<script>
import ContextMenuRemocaoTicket from './context-menu/remocao-ticket'
import {defineReboqueAuto} from '../../../domain/callcenter/services'
import printError from '../../../utils/printError'
// import {USpinnerHourglass} from 'uloc-vue'

export default {
  name: 'TicketsAtivos',
  components: {ContextMenuRemocaoTicket},
  props: ['remocoes'],
  data () {
    return {
      defineReboquistaLoding: false
    }
  },
  methods: {
    definirReboquista (remocao) {
      this.defineReboquistaLoding = true
      defineReboqueAuto(remocao)
        .then((response) => {
          let data = response.data
          console.log(data)
          /* this.$uloc.dialog({
            title: 'Reboquista definido!',
            message: `O reboquista ${data.reboquista.nome} ID ${data.reboquista.id} foi definido com sucesso para a remoção.`
          }) */
          alert(`O reboquista ${data.reboquista.nome} ID ${data.reboquista.id} foi definido com sucesso para a remoção.`)
        })
        .catch((response) => {
          this.defineReboquistaLoding = false
          /* this.$uloc.notify({
            color: 'negative',
            message: `Erro ao tentar definir um reboquista "${printError(response)}"`
          }) */
          alert(`Erro ao tentar definir um reboquista "${printError(response)}"`)
        })
    }
  }
}
</script>

<style lang="scss">
  .tickets-ativos {

    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #ecf1f8;
    width: 250px;
    padding: 0 15px;
    user-select: none;
    overflow: auto;
    box-shadow: 0 1px 4px 0 rgba(192, 208, 230, .8);
    transition: 0.3s all;

    &.nodata {
      width: 0;
      padding: 0;
      overflow: hidden;
      text-indent: -5000px;
    }

    h3 {
      text-align: center;
      font-size: 17px;
      text-transform: uppercase;
      font-weight: 600;
    }

    .item {
      background: #fff;
      border-radius: 5px;
      -webkit-box-shadow: 0 1px 4px 0 rgba(192, 208, 230, .8);
      box-shadow: 0 1px 4px 0 rgba(192, 208, 230, .8);
      padding: 10px;
      margin-bottom: 15px;

      h5 {
        font-size: 14px;
        text-transform: uppercase;
        line-height: initial;
      }

      small {
        display: block;
        font-size: 11px;
        margin: 0px 0 2px 0;
        color: #7b7b7b;
        letter-spacing: 0.02em;
      }

      > ul {
        position: relative;
        overflow: hidden;
        padding: 0;
        margin-top: 8px;

        > li {
          position: relative;
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          font-size: 11px;
          color: #616161;

          span {
            margin-left: 6px;
            font-size: 11px;
            color: #212121;
          }

          &:before {
            content: '';
            width: 10px;
            height: 10px;
            display: block;
            background-color: #dadada;
            border-radius: 100%;
            margin-right: 7px;
            position: relative;
            z-index: 3;
          }
        }

        li:last-child {
          margin-bottom: 0;
        }

        li.ativo {
          &:before {
            background-color: #0081ff;
          }

          &:after {
            content: '';
            position: absolute;
            height: 170%;
            width: 1.5px;
            left: 4px;
            top: 11px;
            background-color: #78a7d6;
          }

          &.completed {
            &:before {
              background-color: #8bff46;
            }

            &:after {
              background-color: #8bff46;
            }
          }
        }

        &:before {
          content: '';
          position: absolute;
          width: 1.5px;
          top: 3px;
          left: 4px;
          height: 100%;
          background-color: #dadada;
        }
      }
    }

    .btn-reboquista {
      font-size: 11px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// TicketsAtivos.vue?76798ed3